import Vue from 'vue'
import App from './App.vue'
import * as VeeValidate from 'vee-validate'
import BootstrapVue from "bootstrap-vue"
import {axiosSetUp, cpdapi, portalapi} from 'src/helpers/axios'
import { router } from './router'
import store from './store'
import { iconsSet as icons } from './assets/icons/icons.js'
import CoreuiVue from '@coreui/vue'
import { ErrorPlugin, ErrorService } from './helpers/errorplugin'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'
// import { checkMyStatus } from './cpd'

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "../src/assets/scss/fonts.scss"
import "@coreui/coreui/dist/css/coreui.min.css"

// require('json.date-extensions')
// JSON.useDateParser()

axiosSetUp()

Vue.config.productionTip = false

console.log("Version:" + process.env.PACKAGE_VERSION)

Vue.use(ErrorPlugin)
Vue.use(BootstrapVue)
Vue.use(CoreuiVue)
Vue.use(VueFilterDateFormat)
Vue.use(VeeValidate)

Vue.use({
  install (Vue) {
    Vue.prototype.$cpdapi = cpdapi
    Vue.prototype.$portalapi = portalapi
  }
})

store.commit('resetStore', 'main')

new Vue({
  
  render: h => h(App),
  router,
  store,
  icons,
  created() {
    this.$store.dispatch('captive/checkOnnet');
    // checkMyStatus();
    this.$store.dispatch('pricing/initialisePrices', false);
    this.$store.dispatch('plan/initialiseSubscription');
    this.$store.dispatch('pricing/initialiseProducts');
    this.$store.dispatch('pricing/initialiseWorldpay');
    this.$store.dispatch('pricing/initialiseUiSettings');
    // this.$store.dispatch('plan/updatePlan');
  }
}).$mount('#app')
